<template>

<v-main class="mt-md-12 mt-8 mb-6">
    <div class="text-center my-2 blueGrey--text">
        <v-icon class=" blueGrey--text">monetization_on</v-icon>
        Экстра бонусы
    </div>
    <v-card
        width=600
        flat
        dark
        class="mx-auto blueDark">
        <div class="text-center pt-6">
            <template v-if="allsum > 0">
            за месяц
            <span class="ml-2 orangeMain--text">{{ allsum | moneyT }} ₽</span>
            </template>
            <template v-else>
                нет данных
            </template>
        </div>
        <v-row class="mx-1" >

            <v-expansion-panels
                accordion
                focusable flat>
                <v-expansion-panel
                    class="blueDark"
                    v-for="(day, id) in days"
                    :key="id">

                    <v-expansion-panel-header>
                        {{ day }}, {{ nameday(day) }}
                        <v-spacer></v-spacer>
                        <span class="orangeMain--text">{{ sumday(day) }} ₽</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <template
                            v-for="(shop, id) in shops"
                            >
                            <template v-if="pays[day][shop] &&
                                            shopinfo[shop.split('@')[0]]">
                                <div
                                    :key="id"
                                    class="pb-3 pt-6">
                                    <v-icon class="blueLigth--text">store</v-icon>
                                    <span class="orangeMain--text">
                                        {{ `${shopinfo[shop.split('@')[0]].ID} ${shopinfo[shop.split('@')[0]].shopname}` }}
                                    </span>
                                    <span class="orangeMain--text">
                                        <v-icon class="blueLigth--text ml-6">access_time</v-icon>
                                        {{ shopgraph(shop, day) }}
                                    </span>
                                </div>

                                <template
                                    v-for="pay in pays[day][shop]">

                                    <v-row
                                        dense
                                        :key="id + pay.username + types[pay.type]"
                                        class="">
                                        <v-col cols="6" 
                                        @click="show_state=true;
                                                user={id: pay.userid},
                                                shopID=pay.shop">
                                                {{ pay.username }}
                                        </v-col>

                                        <v-col cols="3">
                                            {{ types[pay.type] }}
                                        </v-col>

                                        <v-col cols="3">
                                            {{ pay.money }} <span>₽</span>
                                        </v-col>
                                    </v-row>
                                </template>
                            </template>
                        </template>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
        <!-- группировка по продавцам за месяц -->
        <template v-if="usersum.length > 0">
            <div class="text-center pt-6">
                по продавцам
            </div>
            <v-simple-table class="blueDark mx-1" >
              <template v-slot:default>
                <tbody>
                    <tr v-for="item in usersum" :key="item.userid">
                        <td @click="show_state=true;
                                    user={id: item.userid},
                                    shopID=item.shop"
                        >{{ item.username }}</td>
                        <td class="orangeMain--text
                                   text-right">{{ item.money }} ₽</td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>  
        </template> 

    </v-card>

    <v-dialog v-model="show_state" max-width="1200">
        <v-card>
          <v-card-title>
            <v-btn color="orange" text @click="show_state=false">Закрыть</v-btn>
          </v-card-title>
          <v-card-text>
            <state :user=user :shop=shopID></state>
          </v-card-text>
        </v-card>
      </v-dialog>
</v-main>

</template>

<script>

import {mapState} from 'vuex'
import axios from 'axios'
import State from '../components/state.vue'

export default {
name: 'Monetization',
components: {
  state: State
},
data: () => ({
    months: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль',
             'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
    daysnames: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
    types: {'daily': "план",
            'aver': "ср.чек"},
    everpay: [],
    show_state: false,
    user: {},
    shopID : ''
}),

computed: {

    ...mapState(['domen', 'totalInfo', 'shopinfo', 'date']),

    pays: function () {
        if (this.everpay.length == 0) return {};
        let pays = {};
        for (let day of this.days){
            for (let shop of this.shops){
                let pay = this.everpay.filter(
                    el => el.day == day && el.shop == shop);
                if (pay.length > 0){
                    if (!pays[day]) pays[day] = {};
                    if (!pays[day][shop]) pays[day][shop] = [];
                    pays[day][shop] = [...pays[day][shop], ...pay].sort(
                        (a, b) =>  a.username - b.username);
                }
            }
        }
        // window.console.log(pays);
        return pays;
    },

    days: function () { // список дней по которым есть выплаты
        if (this.everpay.length == 0) return [];
        let days = this.everpay.map(el => el.day).filter(
            (v, i, a) => a.indexOf(v) === i).sort((a, b)=>  a - b);
        return days;
    },

    shops: function () { // список магазинов по которым есть выплаты
        if (this.everpay.length == 0) return [];
        let shops = this.everpay.map(el => el.shop).filter(
            (v, i, a) => a.indexOf(v) === i).sort((a, b) =>  a - b);
        return shops;
    },

    allsum: function () { // общая сумма выплат
        if (this.everpay.length == 0) return 0;
        return this.everpay.map(el => el.money).reduce((a, b) => a + b);
    },

    usersum: function () { // шоуппировка по продавцам за месяц
        if (this.everpay.length == 0) return [];
        let users = new Set(this.everpay.map(el => el.userid));
        let result = [];
        for (let user of users){
            let pays = this.everpay.filter(el => el.userid == user);
            if (pays.length == 0) continue;
            let name = pays[0].username;
            result.push({'userid': user,
                         'username': name,
                         'shop': pays[0].shop.split('@')[0],
                         'money': pays.map(el => el.money).reduce(
                            (a,b) => a + b)});
        }
        result.sort((a, b) => { 
            if (a.username > b.username) return 1; 
            if (a.username < b.username) return -1;
            return 0; 
        });
        return result;
    }


},

methods: {

    async datapay () { // данные по выплатам
        let year = new Date(this.date).getFullYear();
        let month = new Date(this.date).getMonth();
        return axios.post(this.domen + '/service/everpay', {
            'year': new Date(this.date).getFullYear(),
            'month': new Date(this.date).getMonth() + 1
        }).then(res => res.data)
            .then(json => {
                if (new Date(this.date).getFullYear() == year &&
                    new Date(this.date).getMonth() == month)
                    this.everpay = json['response'];
            })
            .catch(err => window.console.warn(err))
    },

    nameday (day){ // получение дня недели
        return this.daysnames[new Date(new Date(this.date).getFullYear(),
                                       new Date(this.date).getMonth(),
                                       +day).getDay()];
    },

    shopgraph (shop, day){ // получение графика работы магазина
        shop = shop.split('@')[0];
        let dayname = this.nameday(+day);
        dayname = dayname[0].toUpperCase() + dayname.slice(1);
        let graph = this.shopinfo[shop].graph[dayname];
        if (!graph) graph = this.shopinfo[shop].graph.other;
        return graph[0] + '-' + graph[1];
    },

    sumday (day){ // сумма за день
        return this.everpay.filter(el => el.day == day).map(el => el.money)
                .reduce((a, b) => a + b);
    }

},

watch: {

    date () {
        this.everpay = [];
        this.datapay();
    }

},

created: function(){
    this.datapay();
},
    
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
